import React, { useContext, useMemo } from 'react';
import { App03SubTask, EntityValidations, IApp03SubTask, ISpecificEntityFormProps, IUser } from '../../types';
import { CrTextField } from '../cr/CrTextField';
import styles from '../../styles/cr.module.scss';
import { CrDropdown } from '../cr/CrDropdown';
import { EntityForm } from '../EntityForm';
import { LookupService } from '../../services';
import { DataContext } from '../DataContext';
import { CrUserPicker } from '../cr/CrUserPicker';

interface ISubTaskFormProps extends ISpecificEntityFormProps {
    workflowUsers: IUser[];
    app03TaskID: number;
}

export const SubTaskForm = (props: ISubTaskFormProps): React.ReactElement => {
    const { dataServices: { app03SubTaskService }, lookupData, loadLookupData: { thresholds } } = useContext(DataContext);

    return (
        <EntityForm<IApp03SubTask, EntityValidations>
            {...props}
            entityName="Sub Work Item"
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: subTask, ValidationErrors: errors } = formState;
                return (
                    <div>
                        <CrTextField
                            label="Name"
                            className={styles.formField}
                            required={true}
                            maxLength={255}
                            value={subTask.Title}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Title')}
                            errorMessage={errors.Title}
                        />

                        <CrTextField
                            label="Details"
                            multiline
                            rows={6}
                            maxLength={10000}
                            className={styles.formField}
                            value={subTask.Details}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Details')}
                        />

                        <CrDropdown
                            label='Stage'
                            className={styles.formField}
                            options={[
                                { key: 'Not Started', text: "Not Started" },
                                { key: 'Started', text: "Started" },
                                { key: 'Completed', text: "Completed" },
                            ]}
                            selectedKey={subTask.Stage}
                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Stage')}
                        />

                        <CrUserPicker
                            label="Assigned To"
                            className={styles.formField}
                            users={props.workflowUsers}
                            selectedUsers={subTask.AssignedToUserID && [subTask.AssignedToUserID]}
                            onChange={u => changeHandlers.changeUserPicker(u, 'AssignedToUserID')}
                        />

                    </div>
                );
            }}
            loadEntity={id => app03SubTaskService.read(id, true, true)}
            loadNewEntity={() => new App03SubTask(props.app03TaskID)}
            loadEntityValidations={() => new EntityValidations()}
            onCreate={rt => app03SubTaskService.create(rt)}
            onUpdate={rt => app03SubTaskService.update(rt.ID, rt)}
        />
    );
};
